export const START_GET_REPEAT_ORDER_LIST = "START_GET_REPEAT_ORDER_LIST";
export const SUCCESS_GET_REPEAT_ORDER_LIST = "SUCCESS_GET_REPEAT_ORDER_LIST";
export const ERROR_GET_REPEAT_ORDER_LIST = "ERROR_GET_REPEAT_ORDER_LIST";

export const START_CREATE_REPEAT_ORDER = "START_CREATE_REPEAT_ORDER";
export const SUCCESS_CREATE_REPEAT_ORDER = "SUCCESS_CREATE_REPEAT_ORDER";
export const ERROR_CREATE_REPEAT_ORDER = "ERROR_CREATE_REPEAT_ORDER";

export const START_UPDATE_REPEAT_ORDER = "START_UPDATE_REPEAT_ORDER";
export const SUCCESS_UPDATE_REPEAT_ORDER = "SUCCESS_UPDATE_REPEAT_ORDER";
export const ERROR_UPDATE_REPEAT_ORDER = "ERROR_UPDATE_REPEAT_ORDER";

export const START_GET_SINGLE_REPEAT_ORDER = "START_GET_SINGLE_REPEAT_ORDER";
export const SUCCESS_GET_SINGLE_REPEAT_ORDER =
  "SUCCESS_GET_SINGLE_REPEAT_ORDER";
export const ERROR_GET_SINGLE_REPEAT_ORDER = "ERROR_GET_SINGLE_REPEAT_ORDER";

export const START_GET_SEARCH_REPEAT_ORDER = "START_GET_SEARCH_REPEAT_ORDER";
export const SUCCESS_GET_SEARCH_REPEAT_ORDER =
  "SUCCESS_GET_SEARCH_REPEAT_ORDER";
export const ERROR_GET_SEARCH_REPEAT_ORDER = "ERROR_GET_SEARCH_REPEAT_ORDER";

export const START_DELETE_REPEAT_ORDER = "START_DELETE_REPEAT_ORDER";
export const SUCCESS_DELETE_REPEAT_ORDER = "SUCCESS_DELETE_REPEAT_ORDER";
export const ERROR_DELETE_REPEAT_ORDER = "ERROR_DELETE_REPEAT_ORDER";

export const START_REPEAT_ORDER_PATIENT_FIELD_LIST =
  "START_REPEAT_ORDER_PATIENT_FIELD_LIST";
export const SUCCESS_REPEAT_ORDER_PATIENT_FIELD_LIST =
  "SUCCESS_REPEAT_ORDER_PATIENT_FIELD_LIST";
export const ERROR_REPEAT_ORDER_PATIENT_FIELD_LIST =
  "ERROR_REPEAT_ORDER_PATIENT_FIELD_LIST";

export const START_UPDATE_REPEAT_ORDER_DATE = "START_UPDATE_REPEAT_ORDER_DATE";
export const SUCCESS_UPDATE_REPEAT_ORDER_DATE =
  "SUCCESS_UPDATE_REPEAT_ORDER_DATE";
export const ERROR_UPDATE_REPEAT_ORDER_DATE = "ERROR_UPDATE_REPEAT_ORDER_DATE";

export const START_UPDATE_GLOBAL_SETTING = "START_UPDATE_GLOBAL_SETTING";
export const SUCCESS_UPDATE_GLOBAL_SETTING = "SUCCESS_UPDATE_GLOBAL_SETTING";
export const ERROR_UPDATE_GLOBAL_SETTING = "ERROR_UPDATE_GLOBAL_SETTING";

export const RESET_REPEAT_ORDER_STATE = "RESET_ORDER_STATE";

export const START_GET_PRINT_REPEAT_ORDER_LIST =
  "START_GET_PRINT_REPEAT_ORDER_LIST";
export const SUCCESS_GET_PRINT_REPEAT_ORDER_LIST =
  "SUCCESS_GET_PRINT_REPEAT_ORDER_LIST";
export const ERROR_GET_PRINT_REPEAT_ORDER_LIST =
  "ERROR_GET_PRINT_REPEAT_ORDER_LIST";

export const START_UPDATE_REPEAT_ORDER_NOTE = "START_UPDATE_REPEAT_ORDER_NOTE";
export const SUCCESS_UPDATE_REPEAT_ORDER_NOTE =
  "SUCCESS_UPDATE_REPEAT_ORDER_NOTE";
export const ERROR_UPDATE_REPEAT_ORDER_NOTE = "ERROR_UPDATE_REPEAT_ORDER_NOTE";

export const START_DELETE_REPEAT_ORDER_NOTE = "START_DELETE_REPEAT_ORDER_NOTE";
export const SUCCESS_DELETE_REPEAT_ORDER_NOTE =
  "SUCCESS_DELETE_REPEAT_ORDER_NOTE";
export const ERROR_DELETE_REPEAT_ORDER_NOTE = "ERROR_DELETE_REPEAT_ORDER_NOTE";

export const START_GET_OOS_ORDER = "START_GET_OOS_ORDER";
export const SUCCESS_GET_OOS_ORDER = "SUCCESS_GET_OOS_ORDER";
export const ERROR_GET_OOS_ORDER = "ERROR_GET_OOS_ORDER";

export const START_GLOBAL_SETTING = "START_GLOBAL_SETTING";
export const SUCCESS_GLOBAL_SETTING = "SUCCESS_GLOBAL_SETTING";
export const ERROR_GLOBAL_SETTING = "ERROR_GLOBAL_SETTING";

export const START_CREATE_MULTI_ORDER = "START_CREATE_MULTI_ORDER";
export const SUCCESS_CREATE_MULTI_ORDER = "SUCCESS_CREATE_MULTI_ORDER";
export const ERROR_CREATE_MULTI_ORDER = "ERROR_CREATE_MULTI_ORDER";

export const START_PRN_DRUG = "START_PRN_DRUG";
export const SUCCESS_PRN_DRUG = "SUCCESS_PRN_DRUG";
export const ERROR_PRN_DRUG = "ERROR_PRN_DRUG";

export const START_GLOBAL_SETTING_ACCESS = "START_GLOBAL_SETTING_ACCESS";
export const SUCCESS_GLOBAL_SETTING_ACCESS = "SUCCESS_GLOBAL_SETTING_ACCESS";
export const ERROR_GLOBAL_SETTING_ACCESS = "ERROR_GLOBAL_SETTING_ACCESS";

export const START_PATIENT_MULTI_ORDER = "START_PATIENT_MULTI_ORDER";
export const SUCCESS_PATIENT_MULTI_ORDER = "SUCCESS_PATIENT_MULTI_ORDER";
export const ERROR_PATIENT_MULTI_ORDER = "ERROR_PATIENT_MULTI_ORDER";

export const START_NEXT_ORDER_CYCLE = "START_NEXT_ORDER_CYCLE";
export const SUCCESS_NEXT_ORDER_CYCLE = "SUCCESS_NEXT_ORDER_CYCLE";
export const ERROR_NEXT_ORDER_CYCLE = "ERROR_NEXT_ORDER_CYCLE";

export const START_ORDER_COUNT_TYPE = "START_ORDER_COUNT_TYPE";
export const SUCCESS_ORDER_COUNT_TYPE = "SUCCESS_ORDER_COUNT_TYPE";
export const ERROR_ORDER_COUNT_TYPE = "ERROR_ORDER_COUNT_TYPE";

export const START_BULK_ORDER_COUNT = "START_BULK_ORDER_COUNT";
export const SUCCESS_BULK_ORDER_COUNT = "SUCCESS_BULK_ORDER_COUNT";
export const ERROR_BULK_ORDER_COUNT = "ERROR_BULK_ORDER_COUNT";

export const START_GET_BULK_ORDER_LIST = "START_GET_BULK_ORDER_LIST";
export const SUCCESS_GET_BULK_ORDER_LIST = "SUCCESS_GET_BULK_ORDER_LIST";
export const ERROR_GET_BULK_ORDER_LIST = "ERROR_GET_BULK_ORDER_LIST"; 

export const START_CREATE_BULK_ORDERS = "START_CREATE_BULK_ORDERS";
export const SUCCESS_CREATE_BULK_ORDERS = "SUCCESS_CREATE_BULK_ORDERS";
export const ERROR_CREATE_BULK_ORDERS = "ERROR_CREATE_BULK_ORDERS";
